var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoldenFrame(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "METAL-1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 180 252",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#Gold);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gold",
    y1: 126,
    x2: 180,
    y2: 126,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#fbc926"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#fffbcc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#f8f0bb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#e7d28e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#cca246"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#c3922e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#eed688"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fffbcc"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rarity_Frame",
    "data-name": "Rarity Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rarity_Frame-2",
    "data-name": "Rarity Frame",
    className: "cls-1",
    d: "M0,3.57V248.43A3.57,3.57,0,0,0,3.57,252H176.43a3.57,3.57,0,0,0,3.57-3.57V3.57A3.57,3.57,0,0,0,176.43,0H3.57A3.57,3.57,0,0,0,0,3.57ZM167.21,243.44H12.36a3.57,3.57,0,0,1-3.58-3.57v-227a3.57,3.57,0,0,1,3.58-3.57H167.21a3.57,3.57,0,0,1,3.57,3.57v227A3.57,3.57,0,0,1,167.21,243.44Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoldenFrame);
export default __webpack_public_path__ + "static/media/goldenFrame.972b28b5b5e969b2c05e2c56d71ad9df.svg";
export { ForwardRef as ReactComponent };